module.exports = __webpack_public_path__ + "static/media/107.c2022ec4.png";